import {
	SET_ITEMS,
	SET_ITEMS_AAXML,
	GO_TO_PREVIOUS_ITEM,
	GO_TO_NEXT_ITEM,
	GO_TO_ITEM,
	RECOVER_SAVED_STATE,
	SHOW_RESULTS,
	RESTART_EXERCISE,
	SET_CORRECT_ANSWER,
	START_RECORDING,
	STOP_RECORDING,
	SET_AUTO_NUM,
	SET_RANDOM_ITEMS,
	SET_RANDOM_ITEMS_ORDER,
	SET_EXERCISE_READY,
	SET_ITEMS_TO_SHOW,
	ANSWER_QUESTION,
	SET_ITEM_MARKED_TEXT,
	SET_AUDIO_PREFIX,
	SET_AUDIO_ENABLED,
	SET_PHONEME,
} from '../actions/types';

// Return object from function to avoid data sharing between instances
const INITIAL_STATE = () => ({
	items: [],
	itemsAAXML: [],
	currentItem: 0,
	correctAnswers: [],
	resultsVisible: false,
	recording: false,
	autoNum: false,
	randomItems: false,
	randomItemsOrder: null,
	exerciseReady: false,
	itemsToShow: undefined,
	questionsAnswered: [],
	itemsMarkedText: [],
	audioPrefix: null,
	audioEnabled: null,
	phoneme: null
});

export default function (state = INITIAL_STATE(), action) {
	switch (action.type) {
		case SET_AUDIO_ENABLED: {
			const newState = { ...state };
			newState.audioEnabled = action.payload;
			return newState;
		}

		case SET_AUDIO_PREFIX: {
			const newState = { ...state };
			newState.audioPrefix = action.payload;
			return newState;
		}

		case ANSWER_QUESTION: {
			const newState = { ...state };
			const { currentItem } = newState;
			newState.questionsAnswered = [...(newState.questionsAnswered || [])];
			newState.questionsAnswered[currentItem] = true;
			return newState;
		}

		case SET_ITEM_MARKED_TEXT: {
			const newState = { ...state };
			const { currentItem, itemsMarkedText } = newState;
			itemsMarkedText[currentItem] = action.payload;
			return newState;
		}

		case SET_CORRECT_ANSWER: {
			const newState = { ...state };
			const { currentItem } = newState;
			newState.correctAnswers = [...newState.correctAnswers];
			newState.correctAnswers[currentItem] = action.payload;
			return newState;
		}

		case SET_RANDOM_ITEMS: {
			const newState = { ...state };
			newState.randomItems = action.payload;
			return newState;
		}

		case SET_PHONEME: {
			const newState = { ...state };
			newState.phoneme = action.payload;
			return newState;
		}

		case SET_ITEMS_TO_SHOW: {
			const newState = { ...state };
			newState.itemsToShow = action.payload || undefined;
			return newState;
		}

		case SET_EXERCISE_READY: {
			const newState = { ...state };
			newState.exerciseReady = true;
			return newState;
		}

		case SET_ITEMS: {
			const newState = { ...state };
			newState.items = action.payload;
			return newState;
		}

		case SET_ITEMS_AAXML: {
			const newState = { ...state };
			newState.itemsAAXML = action.payload;
			return newState;
		}

		case GO_TO_PREVIOUS_ITEM: {
			const newState = { ...state };
			if (newState.resultsVisible) {
				newState.resultsVisible = false;
				newState.currentItem = newState.items.length - 1;
			} else {
				newState.currentItem--;
			}
			return newState;
		}

		case GO_TO_NEXT_ITEM: {
			const newState = { ...state };
			newState.currentItem++;
			return newState;
		}

		case GO_TO_ITEM: {
			const newState = { ...state };
			newState.currentItem = action.payload;
			newState.resultsVisible = false;
			return newState;
		}

		case SHOW_RESULTS: {
			const newState = { ...state };
			newState.resultsVisible = true;
			newState.currentItem = null;
			return newState;
		}

		case RECOVER_SAVED_STATE: {
			const newState = { ...state };
			newState.currentItem = action.payload.currentItem;
			newState.correctAnswers = action.payload.correctAnswers;
			newState.resultsVisible = action.payload.resultsVisible;
			newState.itemsToShow = action.payload.itemsToShow;
			newState.randomItemsOrder = action.payload.randomItemsOrder;
			newState.questionsAnswered = action.payload.questionsAnswered;
			newState.itemsMarkedText = action.payload.itemsMarkedText;
			return newState;
		}

		case RESTART_EXERCISE: {
			return {
				...INITIAL_STATE(),
				itemsAAXML: state.itemsAAXML,
				items: state.items,
				correctAnswers: [],
				exerciseReady: true,
				itemsToShow: state.itemsToShow,
				randomItems: state.randomItems,
				randomItemsOrder: state.randomItemsOrder,
				autoNum: state.autoNum,
				questionsAnswered: [],
				itemsMarkedText: []
			};
		}

		case START_RECORDING: {
			const newState = { ...state };
			newState.recording = true;
			return newState;
		}

		case STOP_RECORDING: {
			const newState = { ...state };
			newState.recording = false;
			return newState;
		}

		case SET_AUTO_NUM: {
			const newState = { ...state };
			newState.autoNum = action.payload;
			return newState;
		}

		case SET_RANDOM_ITEMS_ORDER: {
			const newState = { ...state };
			newState.randomItemsOrder = action.payload;
			return newState;
		}

		default:
			return state;
	}
}
